/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ParentRoleBatchRemoveRequest
 */
export interface ParentRoleBatchRemoveRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof ParentRoleBatchRemoveRequest
     */
    parentRoleIds: Array<number>;
}

/**
 * Check if a given object implements the ParentRoleBatchRemoveRequest interface.
 */
export function instanceOfParentRoleBatchRemoveRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "parentRoleIds" in value;

    return isInstance;
}

export function ParentRoleBatchRemoveRequestFromJSON(json: any): ParentRoleBatchRemoveRequest {
    return ParentRoleBatchRemoveRequestFromJSONTyped(json, false);
}

export function ParentRoleBatchRemoveRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParentRoleBatchRemoveRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'parentRoleIds': json['parentRoleIds'],
    };
}

export function ParentRoleBatchRemoveRequestToJSON(value?: ParentRoleBatchRemoveRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'parentRoleIds': value.parentRoleIds,
    };
}

